import { inject, Injectable } from '@angular/core';
import { deleteObject, getDownloadURL, ref, uploadBytesResumable, Storage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private storage = inject(Storage);

  async uploadImage(file: File): Promise<string> {
    try {
      const fileName = 'IMG-' + new Date().getTime();
      const filePath = `images/${fileName}`;
      const storageRef = ref(this.storage, filePath);
      await uploadBytesResumable(storageRef, file, {
        contentType: 'application/image',
      });
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

  deleteImage(imageUrl: string): Promise<void> {
    const imageRef = ref(this.storage, imageUrl);
    return deleteObject(imageRef);
  }
}
